import { API, ENDPOINTS } from '@/app/services/api-url';
import SharedItem from '@/app/modules/home/components/shared-item/shared-item.vue';

export default {
  name: 'recent-activity',
  components: {
    SharedItem,
  },
  data: () => ({
    shares: [],
    loading: true,
  }),
  methods: {
    async loadRecentActivity() {
      const response = await API.get(ENDPOINTS.GET_SHARES);
      if (response.data.data) {
        this.shares = response.data.data;
      }
      this.loading = false;
    },
  },
  async mounted() {
    await this.loadRecentActivity();
  },
};
